<template>
  <div>
    <KTPortlet>
      <template v-slot:toolbar></template>
      <template v-slot:body>
        <OffersTable>
          <template slot="title">{{
            $t("UPDATE_REQUEST.SUB_TITLE", { id: $route.params.id })
          }}</template>
        </OffersTable>
      </template>
    </KTPortlet>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import OffersTable from "@/views/partials/offers/OffersTable.vue";

export default {
  name: "UpdateQuickOffer",
  components: {
    KTPortlet,
    OffersTable,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("LIST_OFFERS.TITLE"), route: "/list-offers" },
      { title: this.$t("UPDATE_REQUEST.TITLE") },
    ]);
  },
};
</script>
